export default {
  FETCH_SITE_OPERATIONAL_STATUS_REQUEST: 'FETCH_SITE_OPERATIONAL_STATUS_REQUEST',
  FETCH_SITE_OPERATIONAL_STATUS_SUCCESS: 'FETCH_SITE_OPERATIONAL_STATUS_SUCCESS',
  FETCH_SITE_OPERATIONAL_STATUS_FAILURE: 'FETCH_SITE_OPERATIONAL_STATUS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/site-operational-status/action-types.js